import React from 'react'

const Footer = () => {
  return (
    <div  className="text-center p-10 mt-10 border-t dark:border-gray-700 border-gray-200">
      
      <h1>2022, My Goggle, Inc.</h1>
    </div>
  )
}

export default Footer